module.exports = __webpack_public_path__ + "img/route.85f1de3f.svg";